<template>
    <div class="view-analytics-top">
        <filter-container 
            :filterData="filterData"
            :filterDataSelected="filterDataSelected"
            :isPreloader="isFilter"
            @onChangeFilter="onChangeFilter"
        />
        <div class="view-analytics__table-container">
            <div class="view-analytics__table-title">
                Топ 15 {{groupingEntitySingle ? (groupingEntitySingle.toLowerCase() + "ов") : ''}}
            </div>
            <table-base-v2
                :isPreloader="isTableClients"
                :columns="tableClients.labels || new Map()"
                :rows="tableClients.rows || []"
                :columnsStyles="columnsStylesClients"
                :isSort="true"
                :columnsSort="columnsSortClients"
                :columnsChartBar="columnsChartBarClients"
            />
        </div>
        <div class="view-analytics__table-container">
            <div class="view-analytics__table-title">
                Топ 15 подрядчиков
            </div>
            <table-base-v2
                :isPreloader="isTableSupplyers"
                :columns="tableSupplyers.labels || new Map()"
                :rows="tableSupplyers.rows || []"
                :columnsStyles="columnsStylesSupplyers"
                :isSort="true"
                :columnsSort="columnsSortSupplyers"
                :columnsChartBar="columnsChartBarSupplyers"
            />
        </div>
        <div class="view-analytics__table-container">
            <div class="view-analytics__table-title">
                Топ 15 прибыльных подрядчиков в разрезе {{groupingEntitySingle ? (groupingEntitySingle.toLowerCase() + "a") : ''}}
            </div>
            <table-base-v2
                :isPreloader="isTableSupplyersClientProfit"
                :columns="tableSupplyersClientProfit.labels || new Map()"
                :rows="tableSupplyersClientProfit.rows || []"
                :columnsStyles="columnsStylesSupplyersClientProfit"
                :isSort="true"
                :columnsSort="columnsSortSupplyersClientProfit"
                :columnsChartBar="columnsChartBarSupplyersClientProfit"
            />
        </div>
        <div class="view-analytics__table-container">
            <div class="view-analytics__table-title">
                Топ 15 убыточных подрядчиков в разрезе {{groupingEntitySingle ? (groupingEntitySingle.toLowerCase() + "a") : ''}}
            </div>
            <table-base-v2
                :isPreloader="isTableSupplyersClientLoss"
                :columns="tableSupplyersClientLoss.labels || new Map()"
                :rows="tableSupplyersClientLoss.rows || []"
                :columnsStyles="columnsStylesSupplyersClientLoss"
                :isSort="true"
                :columnsSort="columnsSortSupplyersClientLoss"
                :columnsChartBar="columnsChartBarSupplyersClientLoss"
            />
        </div>
    </div>
</template>

<script>
import mixinAnalytics from '../../mixins/mixinAnalytics';
import FilterContainer from '../../components/Filter/FilterContainer';
import TableBaseV2 from '../../components/Tables/TableBaseV2';
import serviceApi from '../../services/serviceApi';
import schemeApi from '../../schemes/schemeApi';
import mixinGroupingEntity from "@/mixins/mixinGroupingEntity";
let {
    routeAnalyticsTotalBudget,
    routeAnalyticsTotalClients,
    routeAnalyticsTotalSupplyers,
    routeAnalyticsTotalClientSupplyers
} = schemeApi;
export default {
    name: 'ViewAnalyticsTop',
    components: {
        FilterContainer,
        TableBaseV2
    },
    mixins: [
        mixinAnalytics,
        mixinGroupingEntity
    ],
    /**
     * Данные компонента
     * @property {Object} tableClients - таблица топ клиентов
     * @property {Object} tableSupplyers - таблица топ подрядчиков
     * @property {Object} tableSupplyersClientProfit - таблица топ прибыльных подрядчиков в разрезе клиента
     * @property {Object} tableSupplyersClientLoss - таблица топ убыточных подрядчиков в разрезе клиента
     * @property {Array} columnsSequence - общая последовательность ключей колонок для таблиц
     * @property {boolean} isFilter - условие показа прелоадера для фильтра
     * @property {boolean} isTableClients - условие показа прелоадера для таблицы топ клиентов 
     * @property {boolean} isTableSupplyers - условие показа прелоадера для таблицы топ подрядчиков
     * @property {boolean} isTableSupplyersClientProfit - условие показа прелоадера для таблицы топ прибыльных подрядчиков в разрезе клиента
     * @property {boolean} isTableSupplyersClientLoss - условие показа прелоадера для таблицы топ убыточных подрядчиков в разрезе клиента
     */
    data: () => ({
        tableClients: {},
        tableSupplyers: {},
        tableSupplyersClientProfit: {},
        tableSupplyersClientLoss: {},
        columnsSequence: [
            'difference',
            'earn', 
            'consumption', 
            'profit', 
            'tax', 
            'profit_without_tax', 
            'count', 
            'average'
        ],
        isFilter: false,
        isTableClients: false,
        isTableSupplyers: false,
        isTableSupplyersClientProfit: false,
        isTableSupplyersClientLoss: false
    }),
    computed: {
        /**
         * тело запроса
         * @returns {Object}
         */
        reqBody() {
            let reqBody = {
                filter_params: this.filterDataSelected
            }
            return reqBody;
        },
        /**
         * последовательность ключей колонок для таблицы топ клиентов
         * @returns {Array}
         */
        columnsSequenceClients() {
            return ['client', ...this.columnsSequence];
        },
        /**
         * последовательность ключей колонок для таблицы топ подрядчиков
         * @returns {Array}
         */
        columnsSequenceSupplyers() {
            return ['supplyer', ...this.columnsSequence];
        },
        /**
         * последовательность ключей колонок для таблицы топ прибыльных/убыточных подрядчиков в разрезе клиента
         * @returns {Array}
         */
        columnsSequenceClientSupplyers() {
            return ['supplyer', 'client', 'city', ...this.columnsSequence]
        },
        /**
         * колонки с гистограммой для таблицы топ клиентов
         * @returns {Object}
         */
        columnsChartBarClients() {
            return this.getColumnsChartBarTop(this.tableClients);
        },
        /**
         * колонки с гистограммой для таблицы топ подрядчиков
         * @returns {Object}
         */
        columnsChartBarSupplyers() {
            return this.getColumnsChartBarTop(this.tableSupplyers);
        },
        /**
         * колонки с гистограммой для таблицы топ прибыльных подрядчиков в разрезе клиента
         * @returns {Object}
         */
        columnsChartBarSupplyersClientProfit() {
            return this.getColumnsChartBarTop(this.tableSupplyersClientProfit);
        },
        /**
         * колонки с гистограммой для таблицы топ убыточных подрядчиков в разрезе клиента
         * @returns {Object}
         */
        columnsChartBarSupplyersClientLoss() {
            return this.getColumnsChartBarTop(this.tableSupplyersClientLoss);
        },
        /**
         * стили для колонок таблицы топ клиентов
         * @returns {Object}
         */
        columnsStylesClients() {
            let columnsStylesClients = {};
            let {labels = new Map()} = this.tableClients;
            labels.forEach((_, key) => {
                switch(key) {
                    case 'client':
                        columnsStylesClients[key] = {'color': '#000'};
                        break;
                    case 'difference':
                        columnsStylesClients[key] = {
                            'color': '#000', 
                            'border-right': '3px solid #f5f7f9',
                            'width': '100px'
                        };
                        break;
                    default:
                        columnsStylesClients[key] = {
                            'text-align': 'right',
                            'width': '100px'
                        };
                        break;
                }
            });
            return columnsStylesClients;
        },
        /**
         * стили для колонок таблицы топ подрядчиков
         * @returns {Object}
         */
        columnsStylesSupplyers() {
            let columnsStylesSupplyers = {};
            let {labels = new Map()} = this.tableSupplyers;
            labels.forEach((_, key) => {
                switch(key) {
                    case 'supplyer':
                        columnsStylesSupplyers[key] = {'color': '#000'};
                        break;
                    case 'difference':
                        columnsStylesSupplyers[key] = {
                            'color': '#000', 
                            'border-right': '3px solid #f5f7f9',
                            'width': '100px'
                        };
                        break;
                    default:
                        columnsStylesSupplyers[key] = {
                            'text-align': 'right',
                            'width': '100px'
                        };
                        break;
                }
            });
            return columnsStylesSupplyers;
        },
        /**
         * стили для колонок таблицы топ прибыльных подрядчиков в разрезе клиента
         * @returns {Object}
         */
        columnsStylesSupplyersClientProfit() {
            let columnsStylesSupplyersClientProfit = {};
            let {labels = new Map()} = this.tableSupplyersClientProfit;
            labels.forEach((_, key) => {
                switch(key) {
                    case 'supplyer':
                    case 'client':
                    case 'city':
                        columnsStylesSupplyersClientProfit[key] = {'color': '#000'};
                        break;
                    case 'difference':
                        columnsStylesSupplyersClientProfit[key] = {
                            'color': '#000', 
                            'border-right': '3px solid #f5f7f9',
                            'width': '100px'
                        };
                        break;
                    default:
                        columnsStylesSupplyersClientProfit[key] = {
                            'text-align': 'right',
                            'width': '100px'
                        };
                        break;
                }
            });
            return columnsStylesSupplyersClientProfit;
        },
        /**
         * стили для колонок таблицы топ убыточных подрядчиков в разрезе клиента
         * @returns {Object}
         */
        columnsStylesSupplyersClientLoss() {
            let columnsStylesSupplyersClientLoss = {};
            let {labels = new Map()} = this.tableSupplyersClientLoss;
            labels.forEach((_, key) => {
                switch(key) {
                    case 'supplyer':
                    case 'client':
                    case 'city':
                        columnsStylesSupplyersClientLoss[key] = {'color': '#000'};
                        break;
                    case 'difference':
                        columnsStylesSupplyersClientLoss[key] = {
                            'color': '#000', 
                            'border-right': '3px solid #f5f7f9',
                            'width': '100px'
                        };
                        break;
                    default:
                        columnsStylesSupplyersClientLoss[key] = {
                            'text-align': 'right',
                            'width': '100px'
                        };
                        break;
                }
            });
            return columnsStylesSupplyersClientLoss;
        },
        /**
         * колонки для сортировки для таблицы топ клиентов
         * @returns {Object}
         */
        columnsSortClients() {
            let columnsSortClients = {};
            if (typeof this.tableClients.labels !== 'undefined') {
                this.tableClients.labels.forEach((_, key) => {
                    switch(key) {
                        case 'difference':
                            break;
                        case 'client':
                            columnsSortClients[key] = {typeColumn: 'String'};
                            break;
                        case 'average':
                            columnsSortClients[key] = {typeColumn: 'Percent'};
                            break;
                        default:
                            columnsSortClients[key] = {typeColumn: 'Number'};
                            break;
                    }
                });
            }
            return columnsSortClients;
        },
        /**
         * колонки для сортировки для таблицы топ подрядчиков
         * @returns {Object}
         */
        columnsSortSupplyers() {
            let columnsSortSupplyers = {};
            if (typeof this.tableSupplyers.labels !== 'undefined') {
                this.tableSupplyers.labels.forEach((_, key) => {
                    switch (key) {
                        case 'difference':
                            break;
                        case 'supplyer':
                            columnsSortSupplyers[key] = {typeColumn: 'String'};
                            break;
                        case 'average':
                            columnsSortSupplyers[key] = {typeColumn: 'Percent'};
                            break;
                        default:
                            columnsSortSupplyers[key] = {typeColumn: 'Number'};
                            break;
                    }
                });
            }
            return columnsSortSupplyers;
        },
        /**
         * колонки для сортировки для таблицы топ прибыльных подрядчиков в разрезе клиента
         * @returns {Object}
         */
        columnsSortSupplyersClientProfit() {
            let columnsSortSupplyersClientProfit = {};
            if (typeof this.tableSupplyersClientProfit.labels !== 'undefined') {
                this.tableSupplyersClientProfit.labels.forEach((_, key) => {
                    switch (key) {
                        case 'difference':
                            break;
                        case 'client':
                        case 'supplyer':
                        case 'city':
                            columnsSortSupplyersClientProfit[key] = {typeColumn: 'String'};
                            break;
                        case 'average':
                            columnsSortSupplyersClientProfit[key] = {typeColumn: 'Percent'};
                            break;
                        default:
                            columnsSortSupplyersClientProfit[key] = {typeColumn: 'Number'};
                            break;
                    }
                });
            }
            return columnsSortSupplyersClientProfit;
        },
        /**
         * колонки для сортировки для таблицы топ убыточных подрядчиков в разрезе клиента
         * @returns {Object}
         */
        columnsSortSupplyersClientLoss() {
            let columnsSortSupplyersClientLoss = {};
            if (typeof this.tableSupplyersClientLoss.labels !== 'undefined') {
                this.tableSupplyersClientLoss.labels.forEach((_, key) => {
                    switch (key) {
                        case 'difference':
                            break;
                        case 'client':
                        case 'supplyer':
                        case 'city':
                            columnsSortSupplyersClientLoss[key] = {typeColumn: 'String'};
                            break;
                        case 'average':
                            columnsSortSupplyersClientLoss[key] = {typeColumn: 'Percent'};
                            break;
                        default:
                            columnsSortSupplyersClientLoss[key] = {typeColumn: 'Number'};
                            break;
                    }
                });
            }
            return columnsSortSupplyersClientLoss;
        }
    },
    mounted() {
        // запрашиваем данные
        this.postBudget();
        this.postClients();
        this.postSupplyers();
        this.postClientSupplyersProfit();
        this.postClientSupplyersLoss();
    },
    methods: {
        /**
         * получить данные для таблицы текущего бюджета
         * @async
         */
        async postBudget() {
            this.isFilter = true;
            try {
                let {data = {}} = await serviceApi.post(routeAnalyticsTotalBudget, this.reqBody);
                let {filter = {}} = data;
                this.setFilterData(filter);
            }
            catch(error) {
                if (error.message === 'not server')
                    alert('Извините, сервер временно недоступен');
            }
            this.isFilter = false;
        },
        /**
         * получить данные для таблицы топа клиентов
         * @async
         */
        async postClients() {
            this.isTableClients = true;
            try {
                let {data = {}} = await serviceApi.post(routeAnalyticsTotalClients, this.reqBody);
                let {data: tableClients = {}} = data;
                let tableClientsCollected = this.collectTableTop(tableClients, this.columnsSequenceClients);
                this.tableClients = {
                    ...tableClientsCollected,
                    title: 'Топ 15 клиентов'
                };
            }
            catch(error) {
                // alert('Не удалось получить данные');
            }
            this.isTableClients = false;
        },
        /**
         * получить данные для таблицы топа подрядчиков
         * @async
         */
        async postSupplyers() {
            this.isTableSupplyers = true;
            try {
                let {data = {}} = await serviceApi.post(routeAnalyticsTotalSupplyers, this.reqBody);
                let {data: tableSupplyers = {}} = data;
                let tableSupplyersCollected = this.collectTableTop(tableSupplyers, this.columnsSequenceSupplyers);
                this.tableSupplyers = {
                    ...tableSupplyersCollected, 
                    title: 'Топ 15 подрядчиков'
                };
            }
            catch(error) {
                // alert('Не удалось получить данные');
            }
            this.isTableSupplyers = false;
        },
        /**
         * получить данные для таблицы топа прибыльных подрядчиков в разрезе клиента
         * @async
         */
        async postClientSupplyersProfit() {
            this.isTableSupplyersClientProfit = true;
            try {
                let {data = {}} = await serviceApi.post(routeAnalyticsTotalClientSupplyers, this.reqBody);
                let {data: tableSupplyersClientProfit = {}} = data;
                let tableSupplyersClientProfitCollected = this.collectTableTop(tableSupplyersClientProfit, this.columnsSequenceClientSupplyers);
                this.tableSupplyersClientProfit = {
                    ...tableSupplyersClientProfitCollected,
                    title: 'Топ 10 прибыльных подрядчиков в разрезе клиента'
                };
            }
            catch(error) {
                // alert('Не удалось получить данные');
            }
            this.isTableSupplyersClientProfit = false;
        },
        /**
         * получить данные для таблицы топа убыточных подрядчиков в разрезе клиента
         * @async
         */
        async postClientSupplyersLoss() {
            this.isTableSupplyersClientLoss = true;
            try {
                let reqBody = {
                    ...this.reqBody,
                    sort: 4
                };
                let {data = {}} = await serviceApi.post(routeAnalyticsTotalClientSupplyers, reqBody);
                let {data: tableSupplyersClientLoss = {}} = data;
                let tableSupplyersClientLossCollected = this.collectTableTop(tableSupplyersClientLoss, this.columnsSequenceClientSupplyers);
                this.tableSupplyersClientLoss = {
                    ...tableSupplyersClientLossCollected,
                    title: 'Топ 10 убыточных подрядчиков в разрезе клиента'
                }
            }
            catch(error) {
                // alert('Не удалось получить данные');
            }
            this.isTableSupplyersClientLoss = false;
        },
        /**
         * событие изменения фильтра
         * @param {Object} newFilterData - новые данные фильтра
         */
        onChangeFilter(newFilterData = {}) {
          this.setFilterSelected(newFilterData);
            this.filterDataSelected = newFilterData;
            this.postBudget();
            this.postClients();
            this.postSupplyers();
            this.postClientSupplyersProfit();
            this.postClientSupplyersLoss();
        },
        /**
         * собрать данные для таблицы
         * @param {Object} tableData - данные таблицы
         * @param {Array} columnsSequence - последовательность ключей колонок таблицы
         * @returns {Object}
         */
        collectTableTop(tableData = {}, columnsSequence = []) {
            let {labels = {}, rows = []} = tableData;
            let labelsCollected = new Map();
            columnsSequence.forEach((columnKey) => {
                labelsCollected.set(columnKey, labels[columnKey] || ''/*'Разница'*/);
            });
            let rowsCollected = rows.map(row => new Object({...row, difference: ''}));
            let tableDataCollected = {
                labels: labelsCollected,
                rows: rowsCollected
            };
            return tableDataCollected;
        },
        /**
         * получить объект настроек для гистограммы
         * @param {Object} tableData - данные таблицы
         * @returns {Object}
         */
        getColumnsChartBarTop(tableData) {
            let columnsChartBar = {};
            let {labels = new Map()} = tableData;
            labels.forEach((_, key) => {
                switch(key) {
                    case 'difference':
                        columnsChartBar[key] = {
                            totalValueCallback: (row) => {
                                let {earn = 0, consumption = 0, profit = 0} = row;
                                let posEarn = Number(earn) > 0 ? earn : 0;
                                let posConsumption = Number(consumption) > 0 ? consumption : 0;
                                let posProfit = Number(profit) > 0 ? profit : 0;
                                return posEarn + posConsumption + posProfit;
                            },
                            fillKeys: ['earn', 'consumption', 'profit']
                        };
                        break;
                    default:
                        break;
                }
            });
            return columnsChartBar;
        }
    },

}
</script>

<style lang="scss" scoped>
    ::v-deep .table-base__td-total {
        border: 1px solid #ddd;
        padding: 5px 5px 5px 5px;
    }
    ::v-deep .table-base__td {
        border: 1px solid #ddd;
        padding: 5px 5px 5px 5px;
        width: 90px;
    }
</style>